module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAVUlEQVQI12Nw31Qw331z4WQGNOCxqWiS2+bCBSBGutumgv8emwvb4ZJANlgMKAcWcN9SWAwSANJVbpuKqqHsYlQjNxc1gCQgphU1MGADQLf0gDCyGAAeRi1WOuEa+AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/arrow-down_1x.png
// module id = 2278
// module chunks = 0